// extracted by mini-css-extract-plugin
export default {"container":"SocialSideNav_container__fkoCR"};